module.exports = __webpack_public_path__ + "static/media/RM007_COVER1_FORPRINT_compressed-01.1d6997e4.jpg";